import React from "react";
import { cn } from "../utils";

const VARIANT_CLASS = {
  line: "aone-skel--line",
  pill: "aone-skel--pill",
  box: "aone-skel--box",
  input: "aone-skel--input",
};

/**
 * Gray placeholder block with a shimmer.
 * variant: line (10px) | pill (18px, round) | box (14×14 checkbox) | input (34px field)
 * Width comes from `width` (number = px, string = any CSS length) or className.
 */
export function Skeleton({ variant = "line", width, className, style, ...props }) {
  return (
    <span
      aria-hidden="true"
      data-slot="skeleton"
      className={cn("aone-skel", VARIANT_CLASS[variant], className)}
      style={width != null ? { width, ...style } : style}
      {...props}
    >
      {variant === "input" && <Skeleton variant="line" width="55%" />}
    </span>
  );
}

export default Skeleton;
